import { Observable } from 'rxjs';
import { FusionApiHttpClient } from '../../../../shared/_services/server-clients';

export type CreatePublisherPayload = {
  publisherName: string;
  signupStep: string;
  coppa: boolean;
  dataUsageRights: string;
  dealBidPriceType: string;
  sellerTypes: string[] | null;
  permissions: Array<{ name: string }>;
  publisherInfo: {
    company: string;
    publisherMediaType: string[];
    publisherAccountType: string;
    network: string | null;
    contactEmail: string;
    address1: string;
    city: string;
    country: string | null;
    zipCode: string;
    integrationType: string[];
    [key: string]: unknown;
  };
  user: {
    firstName: string;
    lastName: string;
    email: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

export type PublisherApiResponse = {
  publisherId: number;
  publisherName: string;
  status: string;
};

export class PublishersApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  createPublisher(payload: CreatePublisherPayload): Observable<PublisherApiResponse> {
    return this.fusionApiHttpClient.plain.post<PublisherApiResponse, CreatePublisherPayload>('publisher', payload);
  }

  deletePublisher(publisherId: number): Observable<void> {
    return this.fusionApiHttpClient.plain.delete<void>(`publisher/${publisherId}`);
  }
}
